export function setPayPal({ state, action }) {
  return { ...state, paypalId: action.paypalId, paypalLinked: action.isPaypalUser };
}

export function openPayPalAccountAlreadyLinkedPopup({ state }) {
  return { ...state, paypalAccountAlreadyLinkedPopupOpen: true };
}

export function closePayPalAccountAlreadyLinkedPopup({ state }) {
  return { ...state, paypalAccountAlreadyLinkedPopupOpen: false };
}

export function closePayPalLoginNotPossibleErrorPopup({ state }) {
  return { ...state, paypalLoginNotPossiblePopupOpen: false };
}

export function openPayPalLoginNotPossibleErrorPopup({ state }) {
  return { ...state, paypalLoginNotPossiblePopupOpen: true };
}
